import { beginTask, endTask } from 'redux-nprogress';
import { get } from 'lodash';
import { redirect, NOT_FOUND } from 'redux-first-router';
import debug from 'debug';
import routes from '../../../routes.global';
import viewNames from '../../../../store/actions/view.types';
import { selectQuery } from '../../../../store/reducers/location.selectors';
import { loadToolDescriptions } from '../../../../store/reducers/toolDescriptions';
// import TEAMS_LANDING_VIEW from '../../TeamsLanding/module/teamsLanding';

const log = debug('huddle:app:team:');

export const STORE_KEY = 'team';
export const selectTeamState = state => state[STORE_KEY];

export const LOAD_TEAM_SUCCESS = `${STORE_KEY}/LOAD_TEAM_SUCCESS`;
export const LOAD_TEAM_ERROR = `${STORE_KEY}/LOAD_TEAM_ERROR`;
export const LOAD_TEAM_STATS_SUMMARY_SUCCESS = `${STORE_KEY}/LOAD_TEAM_STATS_SUMMARY_SUCCESS`;
export const LOAD_TEAM_STATS_SUMMARY_ERROR = `${STORE_KEY}/LOAD_TEAM_STATS_SUMMARY_ERROR`;
export const LOAD_TEAM_NEWS_SUCCESS = `${STORE_KEY}/LOAD_TEAM_NEWS_SUCCESS`;
export const LOAD_TEAM_NEWS_ERROR = `${STORE_KEY}/LOAD_TEAM_NEWS_ERROR`;
export const LOAD_TEAM_SEASON_STATS_SUCCESS = `${STORE_KEY}/LOAD_TEAM_SEASON_STATS_SUCCESS`;
export const LOAD_TEAM_SEASON_STATS_ERROR = `${STORE_KEY}/LOAD_TEAM_SEASON_STATS_ERROR`;
export const LOAD_TEAM_WEEKLY_STATS_SUCCESS = `${STORE_KEY}/LOAD_TEAM_WEEKLY_STATS_SUCCESS`;
export const LOAD_TEAM_WEEKLY_STATS_ERROR = `${STORE_KEY}/LOAD_TEAM_WEEKLY_STATS_ERROR`;
export const LOAD_TEAM_ROSTER_SUCCESS = `${STORE_KEY}/LOAD_TEAM_ROSTER_SUCCESS`;
export const LOAD_TEAM_ROSTER_ERROR = `${STORE_KEY}/LOAD_TEAM_ROSTER_ERROR`;

export const CLEAR_TEAM = `${STORE_KEY}/CLEAR_TEAM`;
export const SET_TEAM_FORMULA = `${STORE_KEY}/SET_TEAM_FORMULA`;
export const SET_TEAM_SEASON = `${STORE_KEY}/SET_TEAM_SEASON`;
export const SET_TEAM_SUBVIEW = `${STORE_KEY}/SET_TEAM_SUBVIEW`;
export const SET_TEAM_YEAR = `${STORE_KEY}/SET_TEAM_YEAR`;
export const SET_TEAM_STAT = `${STORE_KEY}/SET_TEAM_STAT`;

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  newsCurrentPageNumber: null,
  newsNumPages: null,
  currentSubview: null,
  currentSeason: null,
  currentFormula: null,
  selectedYear: null,
  description: null,
  summary: null,
  wltRecord: null,
  news: null,
  roster: null,
  seasonStats: null,
  weeklyStats: null,
  seasonStatsColMappings: null,
  weeklyStatsColMappings: null,
  teamDataHasLoaded: false,
  teamRosterHasLoaded: false,
  teamStatsSummaryHasLoaded: false,
  teamNewsHasLoaded: false,
  teamSeasonStatsHasLoaded: false,
  teamWeeklyStatsHasLoaded: false,
  error: null,
};

const teamReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_TEAM_FORMULA:
    case SET_TEAM_SEASON:
    case SET_TEAM_SUBVIEW:
      return { ...state, ...action.payload };
    case SET_TEAM_YEAR:
      return { ...state, ...action.payload };
    case SET_TEAM_STAT:
      return {... state, ...action.payload};
    case CLEAR_TEAM:
      return { ...state, ...initialState };
    case LOAD_TEAM_SUCCESS:
      return { ...state, ...action.payload, teamDataHasLoaded: true };
    case LOAD_TEAM_STATS_SUMMARY_SUCCESS:
      return { ...state, ...action.payload, teamStatsSummaryHasLoaded: true };
    case LOAD_TEAM_NEWS_SUCCESS:
      return { ...state, ...action.payload, teamNewsHasLoaded: true };
    case LOAD_TEAM_SEASON_STATS_SUCCESS:
      return { ...state, ...action.payload, teamSeasonStatsHasLoaded: true };
    case LOAD_TEAM_WEEKLY_STATS_SUCCESS:
      return { ...state, ...action.payload, teamWeeklyStatsHasLoaded: true, error: null };
    case LOAD_TEAM_ROSTER_SUCCESS:
      return { ...state, ...action.payload, teamRosterHasLoaded: true };
    case LOAD_TEAM_WEEKLY_STATS_ERROR:
    case LOAD_TEAM_NEWS_ERROR:
    case LOAD_TEAM_SEASON_STATS_ERROR:
    case LOAD_TEAM_ERROR:
    case LOAD_TEAM_STATS_SUMMARY_ERROR:
    case LOAD_TEAM_ROSTER_ERROR:
      return { ...state, error: action.payload.error };
    default:
      return state;
  }
};

export default teamReducer;

// ------------------------------------
// Update season/formula/view
// ------------------------------------
export const setTeamFormula = formula => ({
  type: SET_TEAM_FORMULA,
  payload: { currentFormula: formula },
});

export const setTeamSeason = season => ({
  type: SET_TEAM_SEASON,
  payload: { currentSeason: season },
});

export const setTeamSubview = subview => ({
  type: SET_TEAM_SUBVIEW,
  payload: { currentSubview: subview },
});

export const setTeamYear = year => ({
  type: SET_TEAM_YEAR,
  payload: { selectedYear: year },
});
export const setStat = stat => ({
  type: SET_TEAM_STAT,
  payload: { statType: stat },
});

// ------------------------------------
// Load Team Data
// ------------------------------------
export const clearTeam = () => ({
  type: CLEAR_TEAM,
});

export const loadTeamSuccess = ({ description }) => ({
  type: LOAD_TEAM_SUCCESS,
  payload: { description },
});

export const loadTeamError = error => ({
  type: LOAD_TEAM_ERROR,
  payload: { error },
});

export const loadTeamStatsSummarySuccess = ({ summary, wlt_record }) => ({
  type: LOAD_TEAM_STATS_SUMMARY_SUCCESS,
  payload: { summary, wltRecord: wlt_record },
});

export const loadTeamStatsSummaryError = error => ({
  type: LOAD_TEAM_STATS_SUMMARY_ERROR,
  payload: { error },
});

export const loadTeamNewsSuccess = ({ news, total_pages, pageNumber }) => ({
  type: LOAD_TEAM_NEWS_SUCCESS,
  payload: { news, newsCurrentPageNumber: pageNumber, newsNumPages: total_pages },
});

export const loadTeamNewsError = error => ({
  type: LOAD_TEAM_NEWS_ERROR,
  payload: { error },
});

export const loadTeamRosterSuccess = ({ roster }) => ({
  type: LOAD_TEAM_ROSTER_SUCCESS,
  payload: { roster },
});

export const loadTeamRosterError = error => ({
  type: LOAD_TEAM_ROSTER_ERROR,
  payload: { error },
});

export const loadTeamSeasonStatsSuccess = ({ seasonStats, seasonStatsColMappings }) => ({
  type: LOAD_TEAM_SEASON_STATS_SUCCESS,
  payload: { seasonStats, seasonStatsColMappings },
});

export const loadTeamSeasonStatsError = error => ({
  type: LOAD_TEAM_SEASON_STATS_ERROR,
  payload: { error },
});

export const loadTeamWeeklyStatsSuccess = ({ weeklyStats, weeklyStatsColMappings }) => ({
  type: LOAD_TEAM_WEEKLY_STATS_SUCCESS,
  payload: { weeklyStats, weeklyStatsColMappings },
});

export const loadTeamWeeklyStatsError = error => ({
  type: LOAD_TEAM_WEEKLY_STATS_ERROR,
  payload: { error },
});

export const loadTeamRoster = teamId => async (dispatch, getState, { api }) => {
  try {
    const { roster } = await api.teams.teamRoster({ teamId });
    dispatch(loadTeamRosterSuccess({ roster }));
  } catch (error) {
    dispatch(loadTeamRosterError(error));
    log(error);
  }
};

export const loadTeamData = id => async (dispatch, getState) => {
  const state = getState();
  if (state.teams && state.teams[id]) {
    const { [id]: description } = state.teams;
    dispatch(loadTeamSuccess({ description }));
  } else {
    dispatch(loadTeamError('Team not found'));
  }
};

export const loadTeamStatsSummary = (season, id, formula) => async (
  dispatch,
  getState,
  { api },
) => {
  try {
    const { summary, wlt_record } = await api.teams.teamStatsSummary({ season, id, formula });
    dispatch(loadTeamStatsSummarySuccess({ summary, wlt_record }));
  } catch (error) {
    dispatch(loadTeamStatsSummaryError(error));
    log(error);
  }
};

export const loadTeamNews = (id, pageSize, pageNumber) => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    const { news, total_pages } = await api.teams.teamNews({ id, pageSize, pageNumber });
    dispatch(loadTeamNewsSuccess({ news, total_pages, pageNumber }));
  } catch (error) {
    dispatch(loadTeamNewsError(error));
    log(error);
  } finally {
    dispatch(endTask());
  }
};

export const loadTeamSeasonStats = (id, formula) => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    const [{ team_stats: seasonStats }, { mappings: seasonStatsColMappings }] =
      await Promise.all([
        api.teams.teamPlayerStatsBySeason({ id, formula }),
        api.teams.teamSeasonStatsColMappings(),
      ]);
    dispatch(loadTeamSeasonStatsSuccess({ seasonStats, seasonStatsColMappings }));
  } catch (error) {
    dispatch(loadTeamSeasonStatsError(error));
    log(error);
  } finally {
    dispatch(endTask());
  }
};

export const loadTeamWeeklyStats = (id, season) => async (
  dispatch,
  getState,
  { api },
) => {
  try {
    dispatch(beginTask());
    const [{ games, players }, { mappings: weeklyStatsColMappings }] =
      await Promise.all([
        api.teams.teamPlayerStatsByWeek({ id, season }),
        api.teams.teamWeeklyStatsMappings(),
      ]);
    dispatch(loadTeamWeeklyStatsSuccess({
      weeklyStats: { games, players },
      weeklyStatsColMappings,
    }));
  } catch (error) {
    dispatch(loadTeamWeeklyStatsError(error));
    log(error);
  } finally {
    dispatch(endTask());
  }
};

export const loadNewFormula = formula => async (dispatch, getState) => {
  const state = getState();
  const { id } = state.team.description;
  const { currentSeason } = state.team;
  dispatch(setTeamFormula(formula));
  await Promise.all([
    dispatch(loadTeamStatsSummary(currentSeason, id, formula)),
    dispatch(loadTeamSeasonStats(id, formula)),
    dispatch(loadTeamWeeklyStats(id, currentSeason)),
  ]);
};

export const loadNewYear = year => async (dispatch, getState) => {
  const state = getState();
  const { id } = state.team.description;
  const { currentFormula } = state.team;
  dispatch(setTeamYear(year));
  await Promise.all([
    dispatch(loadTeamStatsSummary(year, id, currentFormula)),
    dispatch(loadTeamSeasonStats(id, currentFormula)),
    dispatch(loadTeamWeeklyStats(id, year)),
  ]);
};

// ------------------------------------
// View / Route
// ------------------------------------
export const TEAM_VIEW = 'team/VIEW';
viewNames[TEAM_VIEW] = 'Team';
routes[TEAM_VIEW] = {
  // Regex check to ensure id is a number
  path: '/nfl-team/:id(\\d+)/:teamName?',
  thunk: async (dispatch, getState) => {
    const state = getState();
    const teamState = selectTeamState(state);
    const selectedYear = selectTeamState(state).selectedYear;
    const { id } = state.location.payload;
    const { page, statType } = selectQuery(state);
    const { [id]: description } = state.teams;
    // Lodash get() avoids error on accessing nested properties
    const defaultSeason = get(state, 'seasonLookup.current.stats.season');
    const { currentFormula, currentSeason } = teamState;
    const { defaultFormula } = state.formulas;
    if (!description) {
      const action = redirect({ type: NOT_FOUND });
      return dispatch(action);
    }
    // These values can't be zero, safe to use short-circuit
    const formula = currentFormula || defaultFormula || 1;
    const year = currentSeason || defaultSeason || 2016;
    const pageSize = 30;
    const pageNumber = page || 1;

    dispatch(clearTeam());
    dispatch(loadTeamSuccess({ description }));
    dispatch(setTeamSubview('news-injuries'));
    dispatch(setTeamFormula(formula));
    dispatch(setTeamSeason(year));
    dispatch(loadTeamData(id));
    dispatch(loadNewYear(year));
    dispatch(setStat(statType));
    await Promise.all([
      dispatch(loadTeamStatsSummary(year, id, formula)),
      dispatch(loadTeamNews(id, pageSize, pageNumber)),
      dispatch(loadTeamRoster(id)),
      dispatch(loadTeamSeasonStats(id, formula)),
      dispatch(loadTeamWeeklyStats(id, year)),
      dispatch(loadToolDescriptions()),
    ]);
  },
};

export const TEAM_VIEW_SUBVIEW = 'team/VIEW_SUBVIEW';
viewNames[TEAM_VIEW_SUBVIEW] = 'Team';
routes[TEAM_VIEW_SUBVIEW] = {
  path: '/nfl-team/:subview/:id(\\d+)/:teamName/',
  thunk: async (dispatch, getState) => {
    const state = getState();
    const teamState = selectTeamState(state);
    const { id, subview } = state.location.payload;
    const { page ,year,statType:stat} = selectQuery(state);
    // Lodash get() avoids error on accessing nested properties
    const defaultSeason = get(state, 'seasonLookup.current.stats.season');
    const { currentFormula, currentSeason, newsNumPages, selectedYear } = teamState;
    const currentId = get(state, 'team.description.id');
    const { defaultFormula } = state.formulas;
    // These values can't be zero, safe to use short-circuit
    const formula = currentFormula || defaultFormula || 1;
    const teamYear = year?year:selectedYear ? selectedYear : (currentSeason || defaultSeason || 2016);
    const currentSeasonReal = currentSeason || defaultSeason;
    const pageSize = 30;
    let pageNumber = page || 1;
    if (newsNumPages && pageNumber > newsNumPages) pageNumber = newsNumPages;
    if (pageNumber < 0) pageNumber = 1;
    dispatch(setStat(stat))
    if (subview === 'news-injuries' || subview === 'stats' || subview === 'roster') {
      if (currentId === id && typeof page === 'undefined') dispatch(setTeamSubview(subview));
      else if (currentId === id && !!page) await dispatch(loadTeamNews(id, pageSize, pageNumber));
      else {
        dispatch(clearTeam());
        dispatch(setTeamSubview(subview));
        dispatch(setTeamFormula(formula));
        dispatch(setTeamSeason(currentSeasonReal));
        dispatch(setTeamYear(teamYear));
        await dispatch(loadTeamData(id));
        await Promise.all([
          dispatch(loadTeamStatsSummary(teamYear, id, formula)),
          dispatch(loadTeamNews(id, pageSize, pageNumber)),
          dispatch(loadTeamRoster(id)),
          dispatch(loadTeamSeasonStats(id, formula)),
          dispatch(loadTeamWeeklyStats(id, teamYear)),
          dispatch(loadToolDescriptions()),
        ]);
      }
    } else {
      const action = redirect({ type: TEAM_VIEW, payload: { id } });
      return dispatch(action);
    }
  },
};

export const viewTeam = ({ id, teamName }) => ({
  type: TEAM_VIEW,
  payload: { id, teamName },
});

export const viewTeamSubview = ({ id, subview, teamName }) => ({
  type: TEAM_VIEW_SUBVIEW,
  payload: { id, subview, teamName },
});



// WEBPACK FOOTER //
// ./src/app/views/Team/module/team.js